/** Only a confirmed missing brand may replace cached data; transient failures preserve it. */
export async function readBrandResponse(response: Response) {
  if (response.status === 404) return null;
  if (!response.ok) throw new Error('Failed to load brand');
  return response.json();
}
